import { drawCartesianAxes, seriesCategories, valueOf } from './axes.js';

function draw(chart, ctx, progress) {
  const categories = seriesCategories(chart.options.series);
  const { yToPixel, xForIndex } = drawCartesianAxes(chart, ctx, categories);
  const hitAreas = [];

  chart.options.series.forEach((s, si) => {
    const color = s.color || chart.options.colors[si % chart.options.colors.length];
    s.data.forEach((d, i) => {
      const px = xForIndex(i);
      const py = yToPixel(valueOf(d));
      const r = 5 * progress;

      ctx.fillStyle = color;
      ctx.globalAlpha = 0.85;
      ctx.beginPath();
      ctx.arc(px, py, r, 0, Math.PI * 2);
      ctx.fill();
      ctx.globalAlpha = 1;

      if (progress >= 1) {
        hitAreas.push({
          contains: (mx, my) => Math.hypot(mx - px, my - py) <= 8,
          distance: (mx, my) => Math.hypot(mx - px, my - py),
          tooltipX: px,
          tooltipY: py,
          label: `<b>${s.name || 'Series ' + (si + 1)}</b><br>${typeof d === 'object' ? d.x ?? d.label : i}: ${valueOf(d)}`,
          raw: { seriesIndex: si, seriesName: s.name, dataIndex: i, x: typeof d === 'object' ? d.x ?? d.label : i, y: valueOf(d) },
        });
      }
    });
  });

  return hitAreas;
}

const ScatterChart = { draw };
export default ScatterChart;
